import { defineComponent as _defineComponent } from 'vue'
import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import useEditor from '@/composables/useEditor'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import useCommonMixin from '@/composables/useCommonMixin'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'
  import { useRoute } from 'vue-router/composables'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FollowupLesson',
  setup(__props) {

  const route = useRoute()
  const { followUp, currentEditorLesson, deleteFollowup } = useEditor(route)
  const { formatDate } = useCommonMixin()
  const { translateString } = useI18n()

  const openFollowupModal = () => {
    eventBus.$emit('show-modal', {
      modalContentComponent: 'FollowupModal',
      modalTitle: translateString('editor.followup.modalTitle'),
      cssClass: 'followup-modal',
      modalCloseCallback: (callback: () => void) => {
        const datePicker = document.querySelector('.mx-datepicker-popup')
        if (typeof callback === 'function' && !datePicker) callback()
      },
    })
  }

return { __sfc: true,route, followUp, currentEditorLesson, deleteFollowup, formatDate, translateString, openFollowupModal, HTMLRenderer, useEditor, LoadingSpinner, useCommonMixin, eventBus, useI18n, useRoute }
}

})